<template>
  <v-flex md6 xs12 mb-2>
    <v-card elevation='2'>
      <v-layout row>
        <v-flex xs7>
          <v-card-title primary-title>
            <h2>{{ offer.title }}</h2>
          </v-card-title>
          <v-card-text>
            <p>{{ offer.text }}</p>
            <v-btn
              class='btn-primary white--text'
              color='#ffa424'
              :target="targetBoxMapper[offer.advertiser]"
              @click="trackClickEvent(offer)"
              :href='offerDetailPath(offer.advertiser)'>
              {{ offer.actionText }}
            </v-btn>
          </v-card-text>
        </v-flex>
        <v-flex xs5>
          <a
            :target="targetBoxMapper[offer.advertiser]"
            :href='offerDetailPath(offer.advertiser)'
            @click="trackClickEvent(offer)">
            <v-img
              :alt='offer.advertiser'
              :src='images[offer.advertiser]'
              min-height='250px'
              contain/>
          </a>
        </v-flex>
      </v-layout>
    </v-card>
  </v-flex>
</template>

<script>
import { mapState } from 'vuex';
import AllConnect from '@/assets/offers/AllConnect.png';
import SpareFoot from '@/assets/offers/SpareFoot.png';
import unpakt from '@/assets/offers/unpakt.png';
import UsedCardboardBoxes from '@/assets/offers/UsedCardboardBoxes.png';
import Bellhop from '@/assets/offers/Bellhop.jpg';

export default {
  name: 'offersListCard',
  computed: {
    ...mapState('HomebuyerOffers', {
      postOfferAction: state => state.postOfferAction,
    }),
  },
  data() {
    return {
      images: {
        AllConnect,
        SpareFoot,
        unpakt,
        UsedCardboardBoxes,
        Bellhop,
      },
      targetBoxMapper: {
        AllConnect: '_blank',
        Bellhop: '_blank',
        SpareFoot: '_blank',
        unpakt: '_blank',
        UsedCardboardBoxes: '_blank',
      },
    };
  },
  props: {
    offer: {
      type: Object,
      required: true,
    },
  },
  methods: {
    offerDetailPath(advertiser) {
      return `/offers/${advertiser}`;
    },
    trackClickEvent(offer) {
      this.$store.dispatch('HomebuyerOffers/trackOfferByAction', {
        action: 'click',
        location: 'homebuyer_offer_portal',
        offer: offer.offerKey,
      });
    },
  },
};
</script>

<style lang='scss' scoped>
.v-card__text {
  padding: 0px 12px 0px 16px;
  font-size: medium;
  line-height: normal;
  width: 100%;
}
.v-card__title{
  padding: 8px 0px 12px 16px;
}
</style>
